export default "__VITE_ASSET__KvOR7XbU__"